import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import {
  Box, Card, CardContent, Typography, Table, TableBody, TableCell,
  TableHead, TableRow, Alert, IconButton, CircularProgress, TextField, Button,
} from '@mui/material';
import { Home, Save, Schedule } from '@mui/icons-material';
import axios from 'axios';

const API = process.env.REACT_APP_API_URL;

export default function TransportTimeSetupPage() {
  const navigate = useNavigate();
  const [rows, setRows] = useState([]);
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(true);

  const headers = { Authorization: `Bearer ${localStorage.getItem('token')}` };

  const load = async () => {
    try { const { data } = await axios.get(`${API}/api/fleet/time-setup`, { headers }); setRows(data); setError(''); }
    catch (err) { setError(err.response?.data?.error || 'Failed to load'); }
    finally { setLoading(false); }
  };
  useEffect(() => { load(); }, []); // eslint-disable-line

  const setField = (i, key, val) => { const r = [...rows]; r[i] = { ...r[i], [key]: val }; setRows(r); };

  const saveRow = async (r) => {
    try {
      await axios.put(`${API}/api/fleet/time-setup/${encodeURIComponent(r.levelCategory)}`,
        { pickupTime: r.pickupTime, departTime: r.departTime }, { headers });
      setError('Saved successfully'); load();
    } catch (err) { setError(err.response?.data?.error || 'Failed to save'); }
  };

  if (loading) return (<Box sx={{ maxWidth: 800, mx: 'auto', mt: 4, textAlign: 'center' }}><CircularProgress /></Box>);

  return (
    <Box sx={{ maxWidth: 800, mx: 'auto', mt: 4 }}>
      <Card elevation={3}>
        <CardContent>
          <Box display="flex" alignItems="center" justifyContent="space-between" mb={2}>
            <Box display="flex" alignItems="center"><Schedule sx={{ mr: 1, color: '#00695c' }} /><Typography variant="h5" sx={{ color: '#00695c' }}>Transport Time Setup</Typography></Box>
            <IconButton onClick={() => navigate('/fleet')} title="Fleet Dashboard"><Home /></IconButton>
          </Box>
          <Typography variant="body2" color="text.secondary" mb={2}>Pickup &amp; departure times per level (derived from a learner's academic stage).</Typography>
          {error && <Alert severity={error.includes('success') ? 'success' : 'error'} sx={{ mb: 2 }}>{error}</Alert>}
          <Table size="small">
            <TableHead><TableRow><TableCell><strong>Level</strong></TableCell><TableCell><strong>Pickup</strong></TableCell><TableCell><strong>Departure</strong></TableCell><TableCell></TableCell></TableRow></TableHead>
            <TableBody>
              {rows.map((r, i) => (
                <TableRow key={r.levelCategory}>
                  <TableCell>{r.levelCategory}</TableCell>
                  <TableCell><TextField size="small" placeholder="HH:mm" value={r.pickupTime || ''} onChange={e => setField(i, 'pickupTime', e.target.value)} sx={{ width: 100 }} /></TableCell>
                  <TableCell><TextField size="small" placeholder="HH:mm" value={r.departTime || ''} onChange={e => setField(i, 'departTime', e.target.value)} sx={{ width: 100 }} /></TableCell>
                  <TableCell><Button size="small" startIcon={<Save />} onClick={() => saveRow(r)}>Save</Button></TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </CardContent>
      </Card>
    </Box>
  );
}
